<div class="p-fluid">
    <form [formGroup]="settingsForm">
        <p-table [value]="settings" 
                [loading]="loading" 
                styleClass="p-datatable-sm"
                [scrollable]="true"
                [resizableColumns]="true"
                [showGridlines]="true"
                [columnResizeMode]="'fit'">
            <ng-template pTemplate="header">
                <tr>
                    <th pResizableColumn class="p-col-6">Name</th>
                    <th pResizableColumn class="p-col-6">Value</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-setting>
                <tr>
                    <td class="p-col-6">{{setting.name}}</td>
                    <td class="p-col-6">
                        <div class="p-d-flex p-ai-center">
                            <ng-container *ngIf="isEditing(setting.code); else viewMode">
                                <p-iconField iconPosition="right">
                                    <p-inputIcon styleClass="pi pi-info-circle"  [pTooltip]="getSuggestedValueTooltip(setting)"
                                    tooltipPosition="top"/>
                                    <input pInputText 
                                        type="number" 
                                        [formControlName]="setting.code"
                                        [min]="1"
                                        [max]="getMaxLimit(setting)"
                                        style="width: 200px"
                                        [ngClass]="{'ng-invalid ng-dirty': settingsForm.get(setting.code)?.invalid && settingsForm.get(setting.code)?.touched}">
                                </p-iconField>
                            </ng-container>
                            <ng-template #viewMode>
                                <span class="p-text-secondary">{{setting.value}}</span>
                            </ng-template>
                            <span class="p-ml-2">
                                <button pButton 
                                    type="button"
                                    [icon]="isEditing(setting?.code) ? 'pi pi-eye' : 'pi pi-pencil'" 
                                    (click)="toggleEdit(setting)"
                                    class="p-button-text"
                                    [disabled]="isSaving(setting.code)"
                                    [pTooltip]="isEditing(setting?.code) ? 'View' : 'Edit'"
                                    tooltipPosition="top">
                                </button>
                                <button pButton 
                                    *ngIf="isEditing(setting.code)"
                                    type="button"
                                    icon="pi pi-save"
                                    (click)="saveSetting(setting)"
                                    [disabled]="!hasChanges(setting) || isSaving(setting.code)"
                                    [loading]="isSaving(setting.code)"
                                    class="p-button-text"
                                    pTooltip="Save"
                                    tooltipPosition="top">
                                </button>
                            </span>
                            <small class="p-error block p-ml-2" *ngIf="settingsForm.get(setting.code)?.invalid && settingsForm.get(setting.code)?.touched">
                                {{getErrorMessage(setting)}}
                            </small>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </form>
</div> 